module.exports = __webpack_public_path__ + "img/copy.c80bde06.svg";